// extracted by mini-css-extract-plugin
export default {"icon":"CreateBookingSubmit_icon__1ZPaU","icon-success":"CreateBookingSubmit_icon-success__S0Unz","icon-error":"CreateBookingSubmit_icon-error__X01wS"};